import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Homee from './pages/Homee'
import About from './component/About/About'
import Cars from '../src/component/Cars/Cars';
import { createBrowserRouter, RouterProvider} from 'react-router-dom';

const router = createBrowserRouter([
  {
    path:'/',
    element:<Homee/>,
  },

  {
    path:'/cars',
    element:<Cars/>
  },

  {
    path:'/about',
    element:<About/>
  },

  {
    path:'/About/cars',
    element:<Homee/>
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);
 
